import { SystemConfig } from "../interface/interfaces";

export const GoalEndpoints = {
  goalDistributionTypes: '/distribution/config',

  allJackpotConfigs: '/jackpot/config',
  newJackpot: '/jackpot/config',
  updateJackpot: '/jackpot/config',

  allGoalTypes: '/goalType/config/goaltype',
  newGoalType: '/goalType/config/create',
  updateGoalType: '/goalType/config/edit',
  assignRule: '/goalType/config/assign',

  winningRuleItems: '/winningRulesItems/config/get',
  newWinningRuleItem: '/winningRulesItems/config/create',
  updateWinningRuleItem: '/winningRulesItems/config/update',

  allGoalRules: '/winningRules/config/get',
  newWinningRule: '/winningRules/config/create',
  updateWinningRule: '/winningRules/config/update',

  allGoalPackages: '/goal/config/packages',
  newGoalPackage: '/goal/config/package/create',
  updateGoalPackage: '/goal/config/package',

  assignGoalType: '/goal/config/assign-goal-type-to-package',
  goalMarkets: '/goalType/config/market',

  newGoalObj: '/goal/config/goal/create',
  allGoals: '/goal/config/goal',
  updateGoal: '/goal/config/goal/update',

  assignGoalEvents: '/goal/config/events',
  assignGoalChannels: '/goal/config/goal/assign-channel',
  unassignGoalEvents: '/goal/config/events/unassign',
  getGoalEvents: '/goal/config/goal/',
  cancelGoal: '/goal/config/goal/',

  goalDetails: '/goal/config/goal/details',
  validateGoal: '/goal/config/goal/validate',
  settleGoal: '/settlement/generate-winning-bets',
  rapportGoal: '/rapport/rapport-list',
  updateRapport: '/rapport/rapport/update',
  reinitializeRapport: '/rapport/rapport/reinitialise',
  confirmRapport: '/rapport/confirmRapport',
  calculateRapport: '/rapport/calculate/',
  distributeWinnings: '/rapport/distribute/',
  cancelgoalsettlement: '/settlement/revert-goal-settlement',
};

export const GoalRouteUrls = {
  goalJackpots: '/home/goal/jackpot',
  goalTypes: '/home/goal/types',
  goalRules: '/home/goal/rules',
  goalPackages: '/home/goal/packages',
  goalItems: '/home/goal',
  goalDetails: '/home/goal',
};

export const BettingConfigsEndpoints = {
  eventRestrictions: {
    cru: '/v2/restriction/events',
    validate: '/v2/restriction/events/validate',
    deactivate: '/v2/restriction/events/deactivate'
  }

};

export const SportEndpoints = {
  sportsEvents: '/sportEvents'
};

export const systemConfigs: SystemConfig[] = [
  { name: 'countryCode', key: 'DEFAULT_COUNTRY_CODE', default:  ""},
  { name: 'phoneNumberLength', key: 'PHONE_NUMBER_LENGTH', default: 10 },
  { name: 'currency', key: 'STR_CURRENCY_CODE', default: 'XOF'},
];
